import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAddWatchlistUseCase {
    execute(
        type: 'linear' | 'vod',
        apiKey: string,
        profileName: string,
        ids: string[],
        token: string,
        identityToken: string
    ): Promise<any>;
}

export class AddWatchlistUseCase implements IAddWatchlistUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        type: 'linear' | 'vod',
        apiKey: string,
        profileName: string,
        ids: string[],
        token: string,
        identityToken: string
    ): Promise<any> {
        const result = await this.profileRepository.addWatchlist(type, apiKey, profileName, ids, token, identityToken);
        return result.data.ids || [];
    }
}
